export const button = {
  REFRESH_PAGE: "Refresh the page",
};
